import { svgs } from "public/assets/svgs"

const CURRENT_HOST = process.env.NEXT_PUBLIC_HOST || "LOCAL"

export const SUBSCRIPTION_COOKIE_NAME =
  CURRENT_HOST === "PRODUCTION"
    ? "prod_subscription_token"
    : CURRENT_HOST === "STAGING"
    ? "staging_subscription_token"
    : CURRENT_HOST === "DEV"
    ? "dev_subscription_token"
    : "local_subscription_token"

export const NOTIFICATIONS_FETCH_LIMIT = 6

// console.log("Subscription cookie name:", SUBSCRIPTION_COOKIE_NAME)
// IntersectionObserver threshold: how much of the loader must be visible before loading more notifications (1.0 = fully visible)
export const NOTIFICATION_INTERSECTION_THRESHOLD = 0.5

// Notification types and their corresponding configurations
export const NOTIFICATION_VARIANT_CONFIG = {
    success: {
        icon: svgs["checkboxCircleFillIcon"],
        fill: "#00BA34",
        bg: "bg-[rgba(0,186,52,0.05)]",
        border: "border-[rgba(0,186,52,0.20)]",
    },
    warning: {
        icon: svgs["errorWarningFillIcon"],
        fill: "#F98600",
        bg: "bg-[rgba(249,134,0,0.05)]",
        border: "border-[rgba(249,134,0,0.20)]",
    },
    failed: {
        icon: svgs["crossCircleFillIcon"],
        fill: "#E92C2C",
        bg: "bg-[rgba(184,49,53,0.05)]",
        border: "border-[rgba(233,44,44,0.14)]",
    },
    default: {
        icon: svgs["notificationLineIcon2"],
        fill: "",
        bg: "bg-[rgba(245,246,250,1)]",
        border: "border-[rgba(68,55,55,0.2)]",
    },
}